module.exports = __webpack_public_path__ + "azure-devops.png";